import React from 'react';
import { Box } from '@mui/material';
import SiteHeader from './SiteHeader';
import OfflineBanner from './OfflineBanner';
import { useOnlineStatus } from '../hooks/useOnlineStatus';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { isOnline } = useOnlineStatus();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
      <SiteHeader />
      <OfflineBanner isOnline={isOnline} />
      <Box sx={{ flex: 1, overflow: 'hidden', bgcolor: 'grey.50', display: 'flex', flexDirection: 'column', '& > *': { flex: 1 } }}>
        {children}
      </Box>
    </Box>
  );
};

export default Layout;